<template>
    <div class="Match">

        <div class="Match__body">

            <div class="Match__line" :class="{ 'Match__line--winner': winner('a') }">

                <div class="Match__player__holder">

                    <div class="Match__player">

                        <img v-if="! isBye(match.nAF)" class="small-flag" :src="flagPath + match.cA.toLowerCase() + '.svg'"
                             :alt="match.cA">

                        <span class="Match__player__fn  generic-medium">{{match.nAF}}</span><span class="Match__player__i generic-medium">{{initial(match.nAF)}}</span>&nbsp;<span v-if="! isBye(match.nAF)" class="Match__player__ln  generic-medium">{{match.nAL}}</span>
                        <span class="Match__player__seed" v-if="match.seedA">[{{match.seedA}}]</span>
                        <span class="Match__player__seed" v-if="showType( 'wc', match.idA )">[WC]</span>

                    </div>

                    <div class="Match__player" v-if="match.nA2F">

                        <img v-if="! isBye(match.nA2F)" class="small-flag" :src="flagPath + match.cA2.toLowerCase() + '.svg'"
                             :alt="match.cA2">

                        <span class="Match__player__fn  generic-medium">{{match.nA2F}}</span><span class="Match__player__i generic-medium">{{initial(match.nA2F)}}</span>&nbsp;<span v-if="! isBye(match.nA2F)" class="Match__player__ln  generic-medium">{{match.nA2L}}</span>
                        <span class="Match__player__seed" v-if="match.seedA">[{{match.seedA}}]</span>
                        <span class="Match__player__seed" v-if="showType( 'wc', match.idA2 )">[WC]</span>

                    </div>

                </div>

                <div v-if="winner('a')" class="Match__winner" v-html="ico_winner"></div>

                <div class="Match__set generic-medium">

                    <ul>
                        <li>-</li>
                        <li>-</li>
                        <li>-</li>
                    </ul>

                </div>

            </div>

            <div class="Match__line" :class="{ 'Match__line--winner': winner('b') }">

                <div class="Match__player__holder">

                    <div class="Match__player">

                        <img v-if="! isBye(match.nBF)" class="small-flag" :src="flagPath + match.cB.toLowerCase() + '.svg'"
                             :alt="match.cB">

                        <span class="Match__player__fn generic-medium">{{match.nBF}}</span><span class="Match__player__i generic-medium">{{initial(match.nBF)}}</span>&nbsp;<span v-if="! isBye(match.nBF)" class="Match__player__ln generic-medium">{{match.nBL}}</span>
                        <span class="Match__player__seed" v-if="match.seedB">[{{match.seedB}}]</span>
                        <span class="Match__player__seed" v-if="showType( 'wc', match.idB )">[WC]</span>

                    </div>

                    <div class="Match__player" v-if="match.nB2F">

                        <img v-if="! isBye(match.nB2F)" class="small-flag"
                             :src="flagPath + match.cB2.toLowerCase() + '.svg'" :alt="match.cB2">

                        <span class="Match__player__fn generic-medium">{{match.nB2F}}</span><span class="Match__player__i generic-medium">{{initial(match.nB2F)}}</span>&nbsp;<span v-if="! isBye(match.nB2F)" class="Match__player__ln generic-medium">{{match.nB2L}}</span>
                        <span class="Match__player__seed" v-if="match.seedB">[{{match.seedB}}]</span>
                        <span class="Match__player__seed" v-if="showType( 'wc', match.idB2 )">[WC]</span>

                    </div>

                </div>

                <div v-if="winner('b')" class="Match__winner" v-html="ico_winner"></div>

                <div class="Match__set generic-medium">

                    <ul>
                        <li>-</li>
                        <li>-</li>
                        <li>-</li>
                    </ul>

                </div>

            </div>

        </div>

        <div class="Match__meta">

            <div class="Match__time">
                <span v-html="ico_clock"></span>
                --:--
            </div>

            <span class="Match__na">
                <span v-html="ico_pointer_right"></span>
                Not available
            </span>

        </div>

    </div>
</template>

<script>
    export default {
        props: ['match', 'flagPath'],
        data() {
            return {
                ico_pointer_right: window.ico_pointer_right,
                ico_winner: window.ico_tick,
                ico_clock: window.ico_clock
            }
        },
        methods: {
            winner(team) {
                if (team == 'a' && this.match.nBF == 'Bye') {
                    return true
                }

                if (team == 'b' && this.match.nAF == 'Bye') {
                    return true
                }

                return false
            },
            initial(name) {

                if ( name == 'Bye' ) {
                    return name
                }

                return `${name.charAt(0)}.`
            },
            findPlayerById( playerId ) {
                if ( playerId == '' )
                    return false

                let found = window.all_players.filter(player => player.player_id == playerId)

                if (found.length >= 1)
                    return found[0]

                return false
            },
            showType( type, playerId ) {
                let player = this.findPlayerById( playerId )

                if ( type == 'wc' && player.is_wild_card == true )
                    return true

                return false;
            },
            isBye(name) {
                if (name == 'Bye') {
                    return true
                }

                if (name == 'Qualifier') {
                    return true
                }

                return false
            }
        }
    }
</script>
